import React from 'react';
import cn from 'classnames';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import { DumboProps as Props } from '../types';
import { styleFromWidthHeight, getDeviationType } from '../../_helpers';
import LiteratureCoverLetter from '../../../LiteratureCoverLetter';
import { DeviationTypes } from '../../../types/deviation';
import s from './MiniText.scss';

// This is not a DS card, just a small placeholder for places that
// are too tiny to show text anyway, ie. the user avatar tooltip
// It's based on antfart-sized lit dumbo
export const MiniText: React.FC<Props> = ({
  className,
  width,
  height,
  responsive,
  deviation,
  deviation: { title },
  'aria-hidden': ariaHidden,
}) => {
  const deviationType = getDeviationType(deviation);
  return (
    <Section
      className={cn(s['root'], className)}
      style={styleFromWidthHeight({ width, height }, responsive)}
      aria-hidden={ariaHidden}
    >
      {deviationType === DeviationTypes.LITERATURE && (
        <LiteratureCoverLetter title={title} isBigEnough={false} />
      )}
      <Heading className={s['title']}>{title}</Heading>
    </Section>
  );
};
MiniText.displayName = 'MiniText';

export default MiniText;
